import { CreditCardUseCase } from './CreditCardUseCase'

export const CreditCardController = {
  handle: ({ ...props }) => CreditCardUseCase.execute(props)
}
